export default "__VITE_ASSET___LFg2llZOV8q9D9gZqRKNg__"